const TEXT_TYPE = { NUMBER: 'number', };
const DISCARD_INPUT_TYPE = {
  DELETE_CONTENT: 'deleteContent',
  DELETE_CONTENT_FORWARD: 'deleteContentForward',
  DELETE_CONTENT_BACKWARD: 'deleteContentBackward',
};

export { TEXT_TYPE, DISCARD_INPUT_TYPE };
